import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import CalculatorPage from './pages/CalculatorPage';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import AuthCallback from './pages/AuthCallback';
import PricingPage from './pages/PricingPage';
import PaymentSuccess from './pages/PaymentSuccess';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Component to handle session_id in hash
const AppRouter = () => {
  const location = useLocation();
  const [visitCount, setVisitCount] = useState(null);

  // Track visit on app load
  useEffect(() => {
    const trackVisit = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        if (response.ok) {
          const data = await response.json();
          setVisitCount(data.total_visits);
        }
      } catch (error) {
        console.error('Error tracking visit:', error);
      }
    };
    trackVisit();
  }, []);

  // Handle session_id in hash synchronously
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route 
        path="/app" 
        element={
          <ProtectedRoute>
            <CalculatorPage visitCount={visitCount} />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
